<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2s"><a id="page_vi"></a><a id="page_vii"></a>Contents</h2>
<p class="toc"><a href="#/xhtml/ack#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/tra#tra">Note on Transliteration</a></p>
<p class="toct"><a href="#/xhtml/int#int">Introduction</a></p>
<p class="toc1"><span href="#/xhtml/chapter01#ch1" title="Link target outside of Sample"><strong>1</strong><span class="space">Informal Citizens: Palestinian Refugees in Syria</span></span></p>
<p class="toc1"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample"><strong>2</strong><span class="space">From Humanitarianism to Development: <span class="small">UNRWA</span> and Palestinian Refugees</span></span></p>
<p class="toc1"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample"><strong>3</strong><span class="space">Ṣumūd and Sustainability: Reinterpreting Development in Palestinian Refugee Camps</span></span></p>
<p class="toc1"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample"><strong>4</strong><span class="space">“Must We Live in Barracks to Convince People We Are Refugees?”: The Politics of Camp Improvement</span></span></p>
<p class="toc1"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample"><strong>5</strong><span class="space">“A Camp Is a Feeling Inside”: Urbanization and the Boundaries of Palestinian Refugee Identity</span></span></p>
<p class="toct"><span href="#/xhtml/bey#con" title="Link target outside of Sample">Conclusion: Beyond Suffering and Victimhood</span></p>
<p class="toct"><span href="#/xhtml/epi#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toct"><span href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/ref#ref" title="Link target outside of Sample">References</span></p>
<p class="toc"><span href="#/xhtml/ind#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?156bbfe4